const MOVE = "move";
const DRINK = "drink";
const VIGGIE = "viggie";
const MILK = "milk";
const SUPER_HEALTH = "super_health";
const MARVEL_HEALTH = "marvel_health";

const MOVE_CATEGORY = "รักออกกำลัง";
const DRINK_CATEGORY = "หยุดยั้ง น้ำหวาน";
const VEGGIE_CATEGORY = "สุขชัวร์ เพิ่มผัก";
const MINK_CATEGORY = "ดื่มดี นมวัว";
const SUPER_HEALTH_CATEGORY = "รวม 4 เป้าหมาย";
const MARVEL_HEALTH_CATEGORY = "รวม 4 เป้าหมาย ระดับโรงเรียน";

const BRONZE = "bronze";
const SILVER = "silver";
const GOLD = "gold";
const PLATNIUM = "platnium";
const MARVEL = "marvel";

const BRONZE_DESC = "เหรียญทองแดง";
const SILVER_DESC = "เหรียญเงิน";
const GOLD_DESC = "เหรียญทอง";
const PLATNIUM_DESC = "เหรียญแพลทินัม";
const SUPER_HEALTH_BRONZE_DESC = "ดาวทองแดง";
const SUPER_HEALTH_SILVER_DESC = "ดาวเงิน";
const SUPER_HEALTH_GOLD_DESC = "ดาวทอง";
const SUPER_HEALTH_PLATNIUM_DESC = "ดาวแพลทินัม";
const MARVEL_DESC = "ถ้วย";

const MOVE_HERO = "MOVE HERO";
const DRINK_HERO = "DRINK HERO";
const VIGGIE_HERO = "VIGGIE HERO";
const MILK_HERO = "MILK HERO";
const SUPER_HEALTH_HERO = "SUPER HEALTH HERO";
const MARVEL_HEALTH_HERO = "MARVEL HEALTH HERO";

const ROOM_LEVEL = "ระดับห้องเรียน";
const CLASS_LEVEL = "ระดับชั้นเรียน";
const SCHOOL_LEVEL = "ระดับโรงเรียน";

export const REWARDS = [
  {
    type: MOVE,
    level: BRONZE,
    image: "bronze1.png",
    category: MOVE_CATEGORY,
    desc: `${BRONZE_DESC} ${MOVE_HERO}`,
    levelInfo: ROOM_LEVEL,
    code: "MOB",
    name: "Move Hero Bronze",
  },
  {
    type: DRINK,
    level: BRONZE,
    image: "bronze2.png",
    category: DRINK_CATEGORY,
    desc: `${BRONZE_DESC} ${DRINK_HERO}`,
    levelInfo: ROOM_LEVEL,
    code: "DRB",
    name: "Drink Hero Bronze",
  },
  {
    type: VIGGIE,
    level: BRONZE,
    image: "bronze3.png",
    category: VEGGIE_CATEGORY,
    desc: `${BRONZE_DESC} ${VIGGIE_HERO}`,
    levelInfo: ROOM_LEVEL,
    code: "VEB",
    name: "Veggie Hero Bronze",
  },
  {
    type: MILK,
    level: BRONZE,
    image: "bronze4.png",
    category: MINK_CATEGORY,
    desc: `${BRONZE_DESC} ${MILK_HERO}`,
    levelInfo: ROOM_LEVEL,
    code: "MIB",
    name: "Milk Hero Bronze",
  },
  {
    type: SUPER_HEALTH,
    level: BRONZE,
    image: "bronze5.png",
    category: SUPER_HEALTH_CATEGORY,
    desc: `${SUPER_HEALTH_BRONZE_DESC} ${SUPER_HEALTH_HERO}`,
    levelInfo: ROOM_LEVEL,
    code: "SHB",
    name: "Super Health Hero Bronze",
  },
  {
    type: MOVE,
    level: SILVER,
    image: "silver1.png",
    category: MOVE_CATEGORY,
    desc: `${SILVER_DESC} ${MOVE_HERO}`,
    levelInfo: CLASS_LEVEL,
    code: "MOS",
    name: "Move Hero Silver",
  },
  {
    type: DRINK,
    level: SILVER,
    image: "silver2.png",
    category: DRINK_CATEGORY,
    desc: `${SILVER_DESC} ${DRINK_HERO}`,
    levelInfo: CLASS_LEVEL,
    code: "DRS",
    name: "Drink Hero Silver",
  },
  {
    type: VIGGIE,
    level: SILVER,
    image: "silver3.png",
    category: VEGGIE_CATEGORY,
    desc: `${SILVER_DESC} ${VIGGIE_HERO}`,
    levelInfo: CLASS_LEVEL,
    code: "VES",
    name: "Veggie Hero Silver",
  },
  {
    type: MILK,
    level: SILVER,
    image: "silver4.png",
    category: MINK_CATEGORY,
    desc: `${SILVER_DESC} ${MILK_HERO}`,
    levelInfo: CLASS_LEVEL,
    code: "MIS",
    name: "Milk Hero Silver",
  },
  {
    type: SUPER_HEALTH,
    level: SILVER,
    image: "silver5.png",
    category: SUPER_HEALTH_CATEGORY,
    desc: `${SUPER_HEALTH_SILVER_DESC} ${SUPER_HEALTH_HERO}`,
    levelInfo: CLASS_LEVEL,
    code: "SHS",
    name: "Super Health Hero Silver",
  },
  {
    type: MOVE,
    level: GOLD,
    image: "gold1.png",
    category: MOVE_CATEGORY,
    desc: `${GOLD_DESC} ${MOVE_HERO}`,
    levelInfo: ROOM_LEVEL,
    code: "MOG",
    name: "Move Hero Gold",
  },
  {
    type: DRINK,
    level: GOLD,
    image: "gold2.png",
    category: DRINK_CATEGORY,
    desc: `${GOLD_DESC} ${DRINK_HERO}`,
    levelInfo: ROOM_LEVEL,
    code: "DRG",
    name: "Drink Hero Gold",
  },
  {
    type: VIGGIE,
    level: GOLD,
    image: "gold3.png",
    category: VEGGIE_CATEGORY,
    desc: `${GOLD_DESC} ${VIGGIE_HERO}`,
    levelInfo: ROOM_LEVEL,
    code: "VEG",
    name: "Veggie Hero Gold",
  },
  {
    type: MILK,
    level: GOLD,
    image: "gold4.png",
    category: MINK_CATEGORY,
    desc: `${GOLD_DESC} ${MILK_HERO}`,
    levelInfo: ROOM_LEVEL,
    code: "MIG",
    name: "Milk Hero Gold",
  },
  {
    type: SUPER_HEALTH,
    level: GOLD,
    image: "gold5.png",
    category: SUPER_HEALTH_CATEGORY,
    desc: `${SUPER_HEALTH_GOLD_DESC} ${SUPER_HEALTH_HERO}`,
    levelInfo: ROOM_LEVEL,
    code: "SHG",
    name: "Super Health Hero Gold",
  },
  {
    type: MOVE,
    level: PLATNIUM,
    image: "platinum1.png",
    category: MOVE_CATEGORY,
    desc: `${PLATNIUM_DESC} ${MOVE_HERO}`,
    levelInfo: CLASS_LEVEL,
    code: "MOP",
    name: "Move Hero Platinum",
  },
  {
    type: DRINK,
    level: PLATNIUM,
    image: "platinum2.png",
    category: DRINK_CATEGORY,
    desc: `${PLATNIUM_DESC} ${DRINK_HERO}`,
    levelInfo: CLASS_LEVEL,
    code: "DRP",
    name: "Drink Hero Platinum",
  },
  {
    type: VIGGIE,
    level: PLATNIUM,
    image: "platinum3.png",
    category: VEGGIE_CATEGORY,
    desc: `${PLATNIUM_DESC} ${VIGGIE_HERO}`,
    levelInfo: CLASS_LEVEL,
    code: "VEP",
    name: "Veggie Hero Platinum",
  },
  {
    type: MILK,
    level: PLATNIUM,
    image: "platinum4.png",
    category: MINK_CATEGORY,
    desc: `${PLATNIUM_DESC} ${MILK_HERO}`,
    levelInfo: CLASS_LEVEL,
    code: "MIP",
    name: "Milk Hero Platinum",
  },
  {
    type: SUPER_HEALTH,
    level: PLATNIUM,
    image: "platinum5.png",
    category: SUPER_HEALTH_CATEGORY,
    desc: `${SUPER_HEALTH_PLATNIUM_DESC} ${SUPER_HEALTH_HERO}`,
    levelInfo: CLASS_LEVEL,
    code: "SHP",
    name: "Super Health Hero Platinum",
  },
  {
    type: MARVEL_HEALTH,
    level: MARVEL,
    image: "marvel health hero.png",
    category: MARVEL_HEALTH_CATEGORY,
    desc: `${MARVEL_DESC} ${MARVEL_HEALTH_HERO}`,
    levelInfo: SCHOOL_LEVEL,
    code: "MHH",
    name: "Marvel Health Hero",
  },
];

export const getRewards = (rewards) => {
  if (!rewards) return [];
  if (Array.isArray(rewards) && rewards.length === 0) return [];

  let result = [];

  for (let i = 0; i < rewards.length; ++i) {
    for (let j = 0; j < REWARDS.length; ++j) {
      if (rewards[i] === REWARDS[j].code) {
        result.push(REWARDS[j]);
        break;
      }
    }
  }
  return result;
};

export const getLastReward = (reward, OnlyObjectKey) => {
  for (let j = 0; j < REWARDS.length; ++j) {
    if (reward === REWARDS[j].code && OnlyObjectKey)
      return REWARDS[j][OnlyObjectKey];

    if (reward === REWARDS[j].code) return REWARDS[j];
  }
  return undefined;
};
